/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ErrorMessage } from '@components/Form/Index';
import { PageComponent } from '@root/pages/Type';
import { Router } from '@root/router';
import NotificationError from '@root/utils/errors/NotificationError';
import PrettyError from '@root/utils/errors/PrettyError';
import { useFormRequest } from '@root/utils/useFormRequest';
import useRouteHref from '@root/utils/useRouteHref';
import withForm, {
    FormHandlerInside,
    FormHandlerInsideResponseMiddleware,
} from '@utils/withForm';
import { useFormikContext } from 'formik';
import getConfig from 'next/config';
import { useTranslation } from 'react-i18next';
import {
    MacroFormValues,
    MacroProps,
    MacroServerResponse,
    MacroSubmitResponse,
} from '../Types';
import MacroContainer from './MacroContainer';
import { init as ValidationSchemaInit } from './Validation';
const { publicRuntimeConfig } = getConfig();

export const MacroInitialValues: MacroFormValues = {
    amount: '',
    payment: 0,
    paymentid: undefined,
};

const Macro: PageComponent<MacroProps> = (props) => {
    const {
        handleForm,
        errorMessage,
        disableEditableAmount = false,
        submitHandler,
        includeBalanceMethod = false,
        includePreinvoiceMethod = true,
        ...rProps
    } = props;
    const { t } = useTranslation('uiPaymentsTopup');
    const { setFieldValue } = useFormikContext();

    const successUrl = useRouteHref('ui_payments_topup_success');
    const cancelUrl = useRouteHref('ui_payments_topup_cancel');

    const { formHandle } = useFormRequest<MacroFormValues, MacroSubmitResponse>(
        {
            url: `${publicRuntimeConfig.API_URL}/account/topup-macro-handle`,
            values: {
                includeBalanceMethod,
                includePreinvoiceMethod,
                successUrl: publicRuntimeConfig.HOST_URL + successUrl,
                cancelUrl: publicRuntimeConfig.HOST_URL + cancelUrl,
            },
        },
        (response) => {
            if (response.invalidAmount) {
                throw new NotificationError(
                    t('mcaro.errors.invalid_amount', {
                        defaultValue: 'Klaidingai nurodyta suma.',
                    }),
                );
            }
            if (response.methodNotFound) {
                throw new NotificationError(
                    t('mcaro.errors.method_not_found', {
                        defaultValue: 'Nurodytas būdas nerasta.',
                    }),
                );
            }
            if (response.invalidMethod) {
                throw new NotificationError(
                    t('topup.errors.method_not_found', {
                        defaultValue: 'Nurodytas klaidingas būdas.',
                    }),
                );
            }
            if (response.notEnoughtInBalance) {
                throw new NotificationError(
                    t('topup.errors.notEnoughtInBalance', {
                        defaultValue: 'Balanse neužtenka lėšų.',
                    }),
                );
            }
            if (response.redirect) {
                return Router.push(response.redirect);
            }
            if (!response.success) {
                throw new PrettyError(
                    t('mcaro.errors.fatalError', {
                        defaultValue: 'Klaida. Prašome mėginti dar kartą.',
                    }),
                );
            }
            // TODO: Implement notifications
            // alert('success!');
        },
        t('macro.errors.fatalError', {
            defaultValue: 'Klaida. Prašome mėginti dar kartą.',
            ns: 'uiPaymentsTopup',
        }),
    );

    const formSubmit: FormHandlerInside<MacroFormValues> = (ctx) => {
        if (submitHandler) {
            const responseMiddleWare: FormHandlerInsideResponseMiddleware<
                MacroServerResponse
            > = (response) => {
                if (typeof response.paymentid === 'number') {
                    setFieldValue('paymentid', response.paymentid);
                } else {
                    setFieldValue('paymentid', undefined);
                }
                if (response.notEnoughtInBalance) {
                    throw new NotificationError(
                        t('macro.errors.notEnoughtInBalance', {
                            defaultValue: 'Balanse neužtenka lėšų.',
                        }),
                    );
                }
            };
            return submitHandler({
                ...ctx,
                responseMiddleWare,
            });
        }
        return formHandle(ctx);
    };

    return (
        <>
            <ErrorMessage errorMessage={errorMessage} />

            <form onSubmit={handleForm(formSubmit)}>
                <MacroContainer
                    {...rProps}
                    includeBalanceMethod={includeBalanceMethod}
                    includePreinvoiceMethod={includePreinvoiceMethod}
                    initialValues={MacroInitialValues}
                    disableEditableAmount={disableEditableAmount}
                />
            </form>
        </>
    );
};

export default withForm<MacroFormValues>({
    initialValues: MacroInitialValues,
    validationSchema: (props) =>
        ValidationSchemaInit((props as MacroProps).disableEditableAmount),
    enableReinitialize: true,
})(Macro);
